import { useAppSelector } from "../hooks";

/**
 * Shared read of the signed-in user's role (SCRUM-1021 follow-up).
 *
 * Single source of truth is the auth slice — `s.auth.userconnected.user.role`,
 * populated on app load by the `/api/users/me` bootstrap in App.jsx (render is
 * gated on `authChecked`, so the role is present by the time any screen renders,
 * and it stays reactive to the store). This replaces the scattered
 * `localStorage.getItem("role")` reads, which were a second, drift-prone source
 * and forced a `useState` + `useEffect` dance in each consumer.
 *
 * Same gold-standard shape as {@link import("./useCurrentPermission").useCurrentPermission}:
 * tiny, returns a primitive — the caller keeps all role-based
 * gating/filtering (the ADMIN check, the author filter, etc.).
 *
 * @returns the role, or null when signed out / not yet loaded
 */
export function useUserRole(): string | null {
  return useAppSelector((s) => s.auth?.userconnected?.user?.role) ?? null;
}
